<div class="return-part-content-area">
    <return-asset-list></return-asset-list>
</div>
<div class="return-part-interaction-area">
    <return-asset-form-details></return-asset-form-details>
</div>